import { object, string } from 'yup';

import { getQuillPlainText } from '../../../components/baseV2';
import { TEXT_AREA_MAX_LENGTH } from '../constants';
import {
  FAMILY_MEMBER_TEXT_MIN_LENGTH,
  MEMBER_ROLE_PARENT_NOT_CAREGIVER,
  SIBLING_DIAGNOSIS_MIN_LENGTH,
} from './constants';

export const PARENT_CAREGIVER_FORM_SCHEMA = object({
  full_name: string()
    .trim()
    .min(FAMILY_MEMBER_TEXT_MIN_LENGTH, `Must be at least ${FAMILY_MEMBER_TEXT_MIN_LENGTH} characters`)
    .required(),
  member_role: string().required(),
  caregiver_type: string()
    .nullable()
    .defined()
    .when('member_role', {
      is: MEMBER_ROLE_PARENT_NOT_CAREGIVER,
      then: (schema) => schema,
      otherwise: (schema) => schema.required(),
    }),
  relationship_to_client: string().required(),
  custody_type: string().required(),
  marital_status: string().required(),
  job_title: string()
    .trim()
    .min(FAMILY_MEMBER_TEXT_MIN_LENGTH, `Must be at least ${FAMILY_MEMBER_TEXT_MIN_LENGTH} characters`)
    .required(),
  email: string().trim().email('Enter a valid email').required(),
  phone: string()
    .matches(/^\d{10}$/, 'Enter a valid 10 digit phone number')
    .required(),
  street_address_line_one: string()
    .trim()
    .min(FAMILY_MEMBER_TEXT_MIN_LENGTH, `Must be at least ${FAMILY_MEMBER_TEXT_MIN_LENGTH} characters`)
    .required(),
  street_address_line_two: string().nullable().optional(),
  street_address_city: string()
    .trim()
    .min(FAMILY_MEMBER_TEXT_MIN_LENGTH, `Must be at least ${FAMILY_MEMBER_TEXT_MIN_LENGTH} characters`)
    .required(),
  street_address_state: string().required(),
  street_address_zip: string()
    .matches(/^\d{5}$/, 'Enter a valid 5 digit zip code')
    .required(),
});

export const CLIENT_SIBLING_FORM_SCHEMA = object({
  sibling_relationship: string().required(),
  sibling_age: string().trim().matches(/^\d+$/, 'Enter a valid age').required(),
  sibling_diagnosis: string()
    .trim()
    .min(SIBLING_DIAGNOSIS_MIN_LENGTH, `Must be at least ${SIBLING_DIAGNOSIS_MIN_LENGTH} characters`)
    .required(),
});

export const CULTURAL_CONSIDERATION_SCHEMA = object({
  cultural_consideration: string()
    .trim()
    .max(TEXT_AREA_MAX_LENGTH, `Must be at most ${TEXT_AREA_MAX_LENGTH} characters`),
});

// The API caps the stored HTML. Markup can exceed that limit while the visible text still fits.
export const CULTURAL_CONSIDERATION_RICH_TEXT_SCHEMA = object({
  cultural_consideration: string()
    .max(TEXT_AREA_MAX_LENGTH, `Must be at most ${TEXT_AREA_MAX_LENGTH} characters`)
    .test(
      'max-text-length',
      `Must be at most ${TEXT_AREA_MAX_LENGTH} characters`,
      (value) => getQuillPlainText(value).length <= TEXT_AREA_MAX_LENGTH,
    ),
});
